import { render, staticRenderFns } from "./JProfession.vue?vue&type=template&id=3833a98a"
import script from "./JProfession.vue?vue&type=script&lang=js"
export * from "./JProfession.vue?vue&type=script&lang=js"
import style0 from "./JProfession.vue?vue&type=style&index=0&id=3833a98a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports